/**
 Bubbles an event from a deep sub-component up to the component tree.
 */
import {isDefined} from "~/lib/helpers/guards";
import {createDecorator} from "vue-class-component";

const VueEventBubble = {
  install(Vue) {
    Vue.prototype.$bubble = function $bubble( event:string, ...args:unknown[]) {

      let component = this;

      const eventParams = {
        stopPropagation: () => component = null
      };

      do {
        component.$emit(event, ...[...args, eventParams]);
        if( isDefined(component)) component = component.$parent;
      } while (component);
    };
  }
};

/**
 * This is the bubble decorator like @Emit(event) of vue-class-decorator
 * @param {string} event
 * @constructor
 * @example @Bubble('foo')
 *          private method(....) {
 *            return 'bar';
 *          }
 *
 *          It's same as : private(....) {
 *            this.$bubble('foo', 'bar');
 *          }
 */
export const Bubble = (event: string) => createDecorator((options, key) => {
  const originalMethod = options.methods[key]

  // Wrap the method and execute bubble !
  options.methods[key] = function wrapperMethod(...args) {
    this.$bubble(event, originalMethod.apply(this, args));
  }
})

export {VueEventBubble} ;

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-6ecfdc94/vue-bubble.tsx" });